/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import useFetchAPI from '../../common/customHooks/useFetchAPI';
import getGooglePhoto from '../../../../../apis/playbook-apis/getGooglePhoto';

const useStyles = makeStyles((theme) => ({
  cardContainer: {
    backgroundColor: '#fff',
    borderRadius: '6px',
    padding: '2rem 1rem 1rem 1rem',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
    margin: '20px auto',
    textAlign: 'center',
    width: '601px',
    height: '646px',
    [theme.breakpoints.down('sm')]: {
      width: '82vw',
    },
    [theme.breakpoints.up('sm')]: {
      width: '79vw !important',
    },
    [theme.breakpoints.up('md')]: {
      width: '39vw !important',
    },
  },
  cardContent: {
    display: 'flex',
    padding: '20px',
    flexDirection: 'column',
    minHeight: '230px',
    [theme.breakpoints.down('sm')]: {
      // height: '230px !important',
    },
  },
  actionButtonContainer: {
    display: 'flex',
    marginTop: '2rem',
    position: 'relative',
    bottom: '0',
  },
  shuffleButton: {
    margin: '0px auto !important',
    backgroundColor: '#ededed !important',
    color: 'black !important',
    borderColor: 'transparent !important',
    textTransform: 'uppercase',
    width: '100% !important',
    borderRadius: '6px',
    height: '52px',
    '& span': {
      fontFamily: 'Raleway, sans-serif !important',
      fontSize: '14px',
      fontWeight: '700',
      lineHeight: '28px',
      letterSpacing: '1px',
      '& svg': {
        fontSize: '1.1rem',
        marginLeft: '0.2rem'
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: '13px',
      },
    },
  },
}));

export default function PlayBookGoogleCard({ restaurants, cardHeader, cardSubHeader, actionLabels }) {
  const classes = useStyles();

  const [restaurantIdx, setRestaurantIdx] = useState(0);
  const [imageSrc, setImageSrc] = useState('');

  const onSuccess = (response) => {
    setImageSrc(response.data.result.result);
  };

  const onError = (err) => {
    console.log('error', err);
  };

  const getPhotoMutation = useFetchAPI(onSuccess, onError, getGooglePhoto, true);

  useEffect(() => {
    getPhotoMutation.mutate({
      photoReference: restaurants[restaurantIdx].photos[0].name,
    });
  }, [restaurantIdx])

  const shuffle = () => {
    let newIdx = restaurantIdx;
    while (true) {
      newIdx = Math.floor(Math.random() * restaurants?.length);
      if (newIdx !== restaurantIdx) {
        break;
      }
    }
    setRestaurantIdx(newIdx);
  }

  // const priceLevelToDollarSign = (priceLevel) => {
  //  let dollarSign = '';
  //  switch(priceLevel) {
  //   case 'PRICE_LEVEL_INEXPENSIVE':
  //     dollarSign = '$';
  //     break;
  //   case 'PRICE_LEVEL_MODERATE':
  //     dollarSign = '$$';
  //     break;
  //   case 'PRICE_LEVEL_EXPENSIVE':
  //     dollarSign = '$$$';
  //     break;
  //   case 'PRICE_LEVEL_VERY_EXPENSIVE':
  //     dollarSign = '$$$$';
  //     break;
  //   default:
  //     dollarSign = '';
  //     break;
  //  }
  //  return dollarSign;
  // }

  return (
    <div className={classes.cardContainer}>
      {cardHeader && <div className='cardHeader'> {cardHeader} </div>}
      {cardSubHeader && <div className='cardSubHeader'> {cardSubHeader}</div>}
      <div>
        <img src={imageSrc} className='cardImage' alt='Restaurant Image' />
      </div>
      <div className={classes.cardContent}>
        <div className='productTitle'>{restaurants[restaurantIdx].displayName.text}</div>
        {/* <div className='address'>
          <a href={restaurants[restaurantIdx]?.googleMapsUri} target='_blank' rel="noreferrer">{restaurants[restaurantIdx]?.formattedAddress}</a>
          </div> */}
        <div className='phoneNumber'>{restaurants[restaurantIdx]?.nationalPhoneNumber}</div>
        {/* <div className='productRange'>{priceLevelToDollarSign(restaurants[restaurantIdx]?.priceLevel)}</div> */}
        <div className={classes.actionButtonContainer}>
          <Button className={classes.shuffleButton} onClick={() => { shuffle() }}>
            {actionLabels[0]}<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16.6851 6.67828C15.5268 4.67869 13.3619 3.33337 10.8823 3.33337C8.07094 3.33337 5.66405 5.06283 4.67028 7.51451M14.6505 7.51451H18V4.1696M5.14823 13.3681C6.30651 15.3677 8.47144 16.713 10.951 16.713C13.7624 16.713 16.1693 14.9835 17.1631 12.5319M7.18283 12.5319H3.83333V15.8768" stroke="#333333" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </Button>
        </div>
      </div>
    </div>

  );
}
